import { atom } from 'recoil'

export const tagsListState = atom({
  key: 'overviewMessageTagsListState',
  default: {
    tagsList: []
  }
})

export const dynamicFiledListState = atom({
  key: 'overviewMessageDynamicFiledList',
  default: {
    dynamicFiledList: []
  }
})

export const endpointsListState = atom({
  key: 'overviewMessageEndpointsList',
  default: {
    endpointsList: undefined,
    endpointsAttachedToList: undefined
  }
})
